module.exports = __webpack_public_path__ + "static/draining-mobile-6c7031d3e1463f9185313b6259f8318b.svg";